import styled from 'styled-components';
import { respondTo } from 'components/styles/_respondTo';

export const PageContentStyled = styled.div`
  min-height: 100vh;
  position: relative;
  //padding-bottom: 60px;
  ${respondTo.desktop`
    display: flex;
  `}
`;
